"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-italic-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
            _react2.default.createElement("path", { d: "M13.552 11.266h1.232l-1.568 7.781H12l1.552-7.78zm1.04-1.617a.861.861 0 0 1-.552-.184c-.155-.123-.232-.302-.232-.536 0-.267.093-.489.28-.665A.916.916 0 0 1 14.736 8c.213 0 .397.064.552.192.155.128.232.31.232.544a.85.85 0 0 1-.28.657.93.93 0 0 1-.648.256z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-italic-on.js
// module id = 1885
// module chunks = 0